<script setup lang="ts">
  import SidebarItem from './sidebar-item.vue'
  // import SidebarItemDropdown from './sidebar-item-dropdown.vue'
  // import SidebarItemDropdownItem from './sidebar-item-dropdown-item.vue'
  import SidebarItemGroup from './sidebar-item-group.vue'
</script>

<template>
  <div>
    <sidebar-item
      :to="{ name: 'dashboard' }"
      icon="i-far-chart-line">
      Dashboard
    </sidebar-item>

    <sidebar-item-group label="Transaksi">
      <sidebar-item
        :to="{ name: 'purchase list' }"
        icon="i-far-cart-arrow-down">
        Pembelian
      </sidebar-item>
      <sidebar-item
        icon="i-far-truck"
        :to="{ name: 'move order sender list' }">
        Kirim Barang
      </sidebar-item>
      <sidebar-item
        icon="i-far-box"
        :to="{ name: 'move order receiver list' }">
        Terima Barang
      </sidebar-item>
      <sidebar-item
        icon="i-far-boxes-stacked"
        :to="{ name: 'move order product pending' }">
        Produk Pending Mutasi
      </sidebar-item>
      <sidebar-item
        icon="i-far-person-walking-arrow-loop-left"
        :to="{ name: 'purchase return list' }">
        Retur Pembelian
      </sidebar-item>
      <sidebar-item
        :to="{ name: 'print barcode purchase' }"
        icon="i-far-barcode">
        Cetak Barcode
      </sidebar-item>
    </sidebar-item-group>

    <sidebar-item-group label="Stock">
      <sidebar-item
        :to="{ name: 'product check stock' }"
        icon="i-far-warehouse-full">
        Cek Stok
      </sidebar-item>
      <sidebar-item
        icon="i-far-rectangle-list"
        :to="{ name: 'product stock card' }">
        Kartu Stok
      </sidebar-item>
      <!-- <sidebar-item
        :to="{ name: 'stock opname list' }"
        icon="i-far-box-circle-check">
        Stock Opname
      </sidebar-item> -->
      <sidebar-item
        icon="i-far-pencil"
        :to="{ name: 'stock adjustment list' }">
        Penyesuaian Stok
      </sidebar-item>
    </sidebar-item-group>

    <sidebar-item-group label="Produk">
      <sidebar-item
        :to="{ name: 'product list' }"
        icon="i-far-boxes-stacked">
        Daftar Produk
      </sidebar-item>
      <sidebar-item
        :to="{ name: 'product group list' }"
        icon="i-far-tag">
        Daftar Grup Produk
      </sidebar-item>
      <sidebar-item
        :to="{ name: 'product price multiplier' }"
        icon="i-far-percent">
        Multiplier Harga Otomatis
      </sidebar-item>
    </sidebar-item-group>

    <sidebar-item-group label="Master">
      <sidebar-item
        icon="i-far-truck-ramp-box"
        :to="{ name: 'supplier list' }">
        Daftar Supplier
      </sidebar-item>
    </sidebar-item-group>

    <sidebar-item-group label="Akun">
      <sidebar-item
        :to="{ name: 'change password' }"
        icon="i-far-user-lock">
        Ganti Password
      </sidebar-item>
    </sidebar-item-group>
  </div>
</template>
